<template>
  <div class="section py-0 px-5">
    <div class="tile app-title">
      <p class="subtitle is-6">Affectation</p>
    </div>
    <b-dropdown
      v-model="value"
      :disabled="!address"
      multiple
      aria-role="list"
      expanded>
      <b-button class="button" slot="trigger" expanded>
        <span>Séléctionner un filtre</span>
        <b-icon class="mr-0" icon="chevron-down"></b-icon>
      </b-button>

      <b-dropdown-item
        :value="affectation.value"
        aria-role="listitem"
        v-for="affectation in affectationFaceLc"
        :key="affectation.value">
        <span> {{affectation.libelle}} </span>
      </b-dropdown-item>
    </b-dropdown>
  </div>
</template>

<script>
import { createNamespacedHelpers } from 'vuex';
import * as types from '@/store/creationOpportunite/venteFacesLc-mutation-type';
import { affectationFaceLc } from '@/configuration/affectationFaceLcFilter';
import gestionErreur from '@/services/general/gestionErreur';

const Panier = createNamespacedHelpers('panier');
const VenteFacesLc = createNamespacedHelpers('venteFacesLc');

export default {
  name: 'affectation-filtre',
  data() {
    return {
      selectedOptions: [],
      affectationFaceLc,
      valid: true,
      codeFace: '',
    };
  },
  computed: {
    ...Panier.mapGetters({
      panneauxLcPanier: 'panneauxLcPanier',
    }),
    ...VenteFacesLc.mapGetters({
      address: 'address',
      affectations: 'affectationFaceLcFilter',
      rayon: 'rayon',
    }),
    value: {
      get() {
        return this.affectations.map(aff => aff.value);
      },
      set(val) {
        const loadingComponent = this.$buefy.loading.open({ container: null });
        this.setAffectaionFilter(affectationFaceLc.filter(aff => val.includes(aff.value)));
        this.gestionPanneauxLC({
          address: this.address,
          codeFace: this.codeFace,
          rayon: this.rayon,
          valid: this.valid,
          panneauxLcPanier: this.panneauxLcPanier,
        }).then(() => {
          loadingComponent.close();
        }).catch((e) => {
          loadingComponent.close();
          gestionErreur('Erreur lors de la recherche des panneaux LC liée aux affectations', e);
        });
      },
    },
  },
  methods: {
    ...VenteFacesLc.mapMutations({
      setAffectaionFilter: types.SET_AFFECTATION_FACE_LC_FILTER,
    }),
    ...VenteFacesLc.mapActions({
      gestionPanneauxLC: 'gestionPanneauxLC',
    }),
  },
  destroyed() {
    this.setAffectaionFilter(affectationFaceLc);
  },
};
</script>
<style lang="scss" >
  a.dropdown-item.is-active {
    background-color:#3598DC !important;
    color: #fff;
  }
</style>



// WEBPACK FOOTER //
// src/components/creationOpportunite/venteFacesLc/filtres/affectation.vue